import React, {
	useEffect, useState
}from "react"
import {
	 Timeline, Pagination
}from "antd"
import {
	useDispatch, useSelector
}from "react-redux"
import {
	managementActions
}from "../store/actions"
import LocalLoading from "../../../components/Loading/Local"
import i18n from "./localization"
import "antd/lib/table/style/index.css"
import moment from 'moment'
import "antd/lib/timeline/style/index.css"
import '../../../pagination.css'

const PositionHistory = (props) => {
	const { userId } = props
	const dispatch = useDispatch()
	const [page, setPage] = useState(1)
	const [showHistory, setShowHistory] = useState(false)
	const pageSize = 10

	const isRu = useSelector((state) => state.globalReducer.isRu)
	const setUserExecutSuccess = useSelector((state) => state.managementReducer.setUserExecutSuccess)
	const userExecutHistory = useSelector((state) => state.managementReducer.userExecutHistory)

	useEffect(() => {
		onPaginationChange(1)
		return () => {
			dispatch(managementActions.clearUserExecutHistory())
		}
	}, [])

	useEffect(() => {
		onPaginationChange(1)
	 }, [setUserExecutSuccess])

	const onPaginationChange = (value) => {
		setPage(value)
		dispatch(managementActions.getUserExecutHistory({
			page     : value,
			pageSize : pageSize,
			userId   : userId
		}))
	  }

	return (
		<>
			{ userExecutHistory ? (
				<>
					{ userExecutHistory.count > 0 && (
						<div className="history-positions">
							<span onClick={ () => setShowHistory(state => !state) }>
								{ i18n.previousPositions[isRu] }
							</span>
							{
								showHistory && 
								<div>
									<Timeline
										id="positionChangeHistoryTimeLine"
										mode="right"
									>
										{ userExecutHistory.items.map((item, index) => {
											return (
												<Timeline.Item
													key={  `page${page}index${index}`  }
													color="#50CFC9"
												>
													<span>
														{ i18n.positionInfoTimeLine[isRu](item.position, item.unitName, moment(item.startDate).format('DD.MM.YYYY'), moment(item.endDate).format('DD.MM.YYYY')) }
													</span>
												</Timeline.Item>
											)
										}) }
									</Timeline>
									{
										userExecutHistory.count > pageSize ?
										(
										<Pagination
													current={ page }
													pageSize={ pageSize }
													showSizeChanger={ false }
													total={ userExecutHistory.count }
													onChange={ onPaginationChange }
										/>
										)
												: null
									}
								</div>
							}
						</div>
					) }
				</>
			) : <LocalLoading/> }
		</>
	)
}

export default PositionHistory
